import React from "react";
import "./Spinner.css";

export function Spinner({ size = 18, label = "Cargando...", className = "" }) {
  return (
    <span
      role="status"
      aria-label={label}
      className={`ui-spinner ${className}`}
      style={{ width: size, height: size, borderWidth: Math.max(2, Math.round(size / 8)) }}
    />
  );
}

export function SpinnerOverlay({ label = "Cargando..." }) {
  return (
    <div className="ui-spinner-overlay">
      <Spinner size={28} />
      <span className="ui-spinner-label">{label}</span>
    </div>
  );
}
